import React, { Component } from 'react';
import { Row, Col, Modal, Button } from 'react-bootstrap';
import PropTypes from 'prop-types';
import I18n from 'i18n-react';
import './BestPricingModal.css';

const defaultProps = {
  firstButtonModal: 'Refazer Busca',
  secondButtonModal: 'Continuar',
  showModal: false,
  message: ''
};

const propTypes = {
  id: PropTypes.string.isRequired,
  firstOption: PropTypes.func.isRequired,
  secondOption: PropTypes.func,
  showModal: PropTypes.bool.isRequired,
  firstButtonModal: PropTypes.string,
  secondButtonModal: PropTypes.string,
  header: PropTypes.string,
  message: PropTypes.any
};

class BestPriceModal extends Component {
  render() {
    return (
      <Modal
        id={`modal-${this.props.id}`}
        show={this.props.showModal}
        onHide={this.props.firstOption}>
        {this.props.header ? (
          <Modal.Header closeButton>
            <Modal.Title>{this.props.header}</Modal.Title>
          </Modal.Header>
        ) : null}
        <Modal.Body bsClass="modal-bestPrice-body">

          <Row>
            <Col
              id={`modal-${this.props.id}-message`}
              sm={12}
              xs={12}
              md={12}
              lg={12}
              className="modal-bestPrice-body-content">
              {this.props.message}
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer bsClass="modal-bestPrice-footer">
          <Row>
            <Col sm={12} xs={12} md={12} lg={12}>
              <Button
                bsClass="modal-bestPrice-button back"
                id={`btn-modal-${this.props.id}`}
                onClick={this.props.firstOption}
                ref={f => (this.firstOption = f)}>
                {this.props.firstButtonModal}
              </Button>
              <Button
                bsClass="modal-bestPrice-button continue"
                id={`btn-modal-${this.props.id}`}
                onClick={this.props.secondOption}
                ref={s => (this.secondOption = s)}>
                {this.props.secondButtonModal}
              </Button> <br></br><br></br>

            </Col>
            <div>
              <span className="modal-bestPrice-rodapeMsg"> {I18n.translate('components.refundRulesDetail.msgBestPriceRodape')}
              </span> </div>
          </Row>
        </Modal.Footer>
      </Modal>
    );
  }
}

BestPriceModal.defaultProps = defaultProps;
BestPriceModal.propTypes = propTypes;

export default BestPriceModal;



// WEBPACK FOOTER //
// ./src/components/common/bestPriceModal/BestPriceModal.jsx